import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const dateInEpochTimeResolver: FieldResolver = (metadata: Metadata) =>
  ({
    dateInEpochTime:
      metadata.getDateTime() !== undefined && !metadata.isDeleted()
        ? Number(metadata.getDateTime())
        : undefined
  } as StreamData)

export default dateInEpochTimeResolver
